export const IMAGE_ALTS_EN = {
  AVATAR: 'Avatar',
};
